export const useDropdown = () => {
  const openDropdownMenu = (
    event: React.MouseEvent<HTMLElement>,
    handleDropDownClick:
      | ((event: React.MouseEvent<HTMLElement>) => void)
      | undefined,
  ) => {
    event.stopPropagation();
    if (handleDropDownClick) {
      handleDropDownClick(event);
    }
  };

  return { openDropdownMenu };
};
